import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f4f5f7;
  width: 100%;
  border-top: solid 1px #dfe1e5;
  padding: 20px 20px 0 20px;

  @media screen and (min-width: 992px) {
    padding-top: 20px 0 0 0;
  }

  .container-footer {
    margin: 0 auto;
    width: 100%;
    max-width: 1200px;
  }

  .navbar {
    margin-top: 20px;
    min-height: 60px;
    display: flex;
    align-items: center;
    border-top: solid 1px #dfe1e5;
  }

  .menus {
    @media screen and (min-width: 700px) {
      display: flex;
      flex-wrap: wrap;
    }

    .logo-container {
      margin-bottom: 20px;

      @media screen and (min-width: 700px) {
        flex: 1 1 100%;
      }

      @media screen and (min-width: 992px) {
        margin-bottom: 0px;
        flex: 1 1 20%;
      }
    }

    .menu {
      margin-bottom: 26px;

      @media screen and (min-width: 700px) {
        flex: 1 1 ${100 / 2}%;
      }

      @media screen and (min-width: 992px) {
        margin-bottom: 0px;
        flex: 1 1 ${80 / 4}%;
      }
    }
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;

  .img {
    width: 40px;
    height: auto;
    margin-right: 10px;
  }

  .title {
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
  }
`;
